import React, { useState, useEffect, useContext } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { getRankingGestoresAsync } from "../../../api/Dashboard";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { simpleMessage } from "../../../helpers/Helpers";
import { isEmpty } from "lodash";
import NoData from "../../../components/NoData";
import { monoFont } from "../../../theme";

const money = (n) => new Intl.NumberFormat("es-NI", { style: "currency", currency: "NIO" }).format(n);

const RankingGestores = ({ selectedSucursal }) => {
  const [datos, setDatos] = useState([]);

  const { setIsLoading, setIsUnautorized } = useContext(DataContext);

  const token = getToken();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getRankingGestoresAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setDatos(result.data.result);
    })();
  }, [selectedSucursal]);

  return (
    <div>
      {isEmpty(datos) ? (
        <NoData />
      ) : (
        <Stack spacing={1.5}>
          {datos.map((item, index) => (
            <Stack key={item.gestor} direction="row" alignItems="center" spacing={1.5}>
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  fontSize: 12,
                  fontWeight: 700,
                  backgroundColor: index === 0 ? "warning.light" : "action.hover",
                  color: index === 0 ? "warning.main" : "text.secondary",
                }}
              >
                {index + 1}
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography noWrap sx={{ fontSize: 12.5, fontWeight: 500 }}>{item.gestor}</Typography>
                <Typography sx={{ fontSize: 11, color: "text.secondary" }}>{item.creditos} créditos</Typography>
              </Box>
              <Typography sx={{ fontFamily: monoFont, fontSize: 12.5, fontWeight: 600 }}>
                {money(item.montoColocado)}
              </Typography>
            </Stack>
          ))}
        </Stack>
      )}
    </div>
  );
};

export default RankingGestores;
